import { render, staticRenderFns } from "./AnnotationDetails.vue?vue&type=template&id=51179391&scoped=true"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetails.vue?vue&type=style&index=0&id=51179391&prod&scoped=true&lang=scss"
import style1 from "./AnnotationDetails.vue?vue&type=style&index=1&id=51179391&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51179391",
  null
  
)

export default component.exports